export default __webpack_public_path__ + "static/media/cashtab_xec.eb6d1077.png";